import {api, routes, activeDomain} from "@/plugins/axios";
import axios from "axios";

export function useAPI() {
	const getDonationValues = (orgID) => {
		return api.get(routes.donations.getValues(orgID)).then((response) => {
			return Promise.resolve(response.data);
		}).catch((err) => {
			return Promise.reject(err);
		});
	}

	const processDonation = (orgSlug, formData) => {
		const route = window.location.protocol + '//' + orgSlug + activeDomain + routes.donations.processDonation
		return axios.post(route, formData, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'multipart/form-data',
			}
		}).then((response) => {
			return Promise.resolve(response.data);
		}).catch((err) => {
			return Promise.reject(err);
		});
	}

	const getCustomDonationFee = (orgID, amount) => {
		return api.get(routes.donations.getCustomDonationFee(orgID, amount)).then((response) => {
			return Promise.resolve(response.data);
		}).catch((err) => {
			return Promise.reject(err);
		});
	}

	return {
		getDonationValues,
		processDonation,
		getCustomDonationFee
	}
}